import React from 'react'
import './App.css'
import { BrowserRouter as Router } from "react-router";
import NavBarPage from './components/navBarPage';
import { AppContextProvider} from './AppContextProvider';
import ErrorBoundary from './components/ErrorBoundary';
import { AppInsightsContext } from "@microsoft/applicationinsights-react-js";
import { reactPlugin } from "./services/applicationInsights";
import { library } from "@fortawesome/fontawesome-svg-core";
import { fab } from "@fortawesome/free-brands-svg-icons";
import { fas } from "@fortawesome/free-solid-svg-icons";
import { far } from "@fortawesome/free-regular-svg-icons";
function App() {
  library.add(fab, fas, far);


  return (
    <React.Fragment>
      <ErrorBoundary>
      <AppInsightsContext.Provider value={reactPlugin}>
      <Router future={{ v7_relativeSplatPath: true }}>
      <AppContextProvider>

            <div className="App" style={{width: "100vw", height: "100vh"}}>
              <NavBarPage />
            </div>
          </AppContextProvider>
          </Router>
      </AppInsightsContext.Provider>
      </ErrorBoundary>
    </React.Fragment>
  )
}

export default App
